import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { colorText, GamificationGameTheme, HighLightColors, TriviaBackgroundColor, TriviaTheme } from '../../../themeConstants'

const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    parent: {
        flex: 1,
        justifyContent: 'center',
    },
    container: {
        width: width,
        height: height,
        flex: 1,
        backgroundColor: TriviaTheme.triviaBackgroundColor,
        alignItems: 'center',
        alignContent: 'center',
    },
    containerModal: {
        width: width,
        height: height,
        backgroundColor: TriviaTheme.triviaBackgroundColor,
        alignItems: 'center',
        alignContent: 'center',
    },
    questionContainer: {
        paddingHorizontal: 15,
        paddingBottom: 10,
    },
    optionsContainer: {
        marginVertical: 20,
    },
    optionsSubContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    buttonContainer: {
        // btn confirmar respuesta
        flexDirection: 'column',
        bottom: 15,
        marginVertical: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonContainerExtra: {
        marginHorizontal: 15,
        alignSelf: 'center',
    },
    marginFive: {
        margin: 5,
    },
    optionText: {
        // titulos
        fontSize: 26,
        fontWeight: 'bold',
        color: colorText,
        marginHorizontal: 0,
        textAlign: 'left',
    },
    backIcon: {
        paddingLeft: 15,
        marginBottom: 8,
    },
    containerEditIcon: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
    },
    containerStarIcon: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
        paddingBottom: 8,
    },
    editIcon: {
        justifyContent: 'Top',
        marginTop: 0,
        paddingHorizontal: 8,
    },
    titleEvaluationText: {
        //titulo top
        fontSize: 14,
        color: TriviaTheme.txtTriviaColorTitles,
        fontWeight: 'bold',
        marginBottom: 4,
        paddingLeft: 15,
    },
    optionTextDetails: {
        // titulo top 2
        fontSize: 15,
        color: TriviaTheme.txtTriviaColorTitles,
        marginBottom: 15,
        paddingLeft: 15,
    },
    completeBlanksContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        paddingTop: 25,
    },
    optionContainer: {
        //btn - marco
        paddingVertical: 10,
        marginHorizontal: 2,
        marginBottom: 12,
        backgroundColor: GamificationGameTheme.fillBlanksOptionUnselectedBackground,
        borderRadius: 20,
        borderColor: 'transparent',
        borderWidth: 3,
    },
    options: {
        // copy btn trivia
        fontSize: 18,
        textAlign: 'center',
        fontWeight: '600',
        color: theme.colors.textPrimary,
        paddingHorizontal: 30,
    },
    selectedOption: {
        backgroundColor: GamificationGameTheme.fillBlanksOptionBackground,
    },
    selectedOptionText: {
        color: GamificationGameTheme.fillBlanksSelectedText,
    },
    correctOptionText: {
        // color btn seleccion multiplechoose
        color: 'white',
    },
    mainButton: {
        width: 'auto',
        marginTop: 10,
        backgroundColor: GamificationGameTheme.interModalButtonBackground,
        paddingVertical: 7,
        paddingHorizontal: 30,
        borderRadius: 15,
        fontSize: 14,
        color: GamificationGameTheme.interModalButtonTextColor,
        fontWeight: 'bold',
        textAlign: 'center',
        overflow: 'hidden',
    },
    borderButtonText2: {
        paddingBottom: 5,
        color: theme.colors.alert,
        fontWeight: 'bold',
        fontSize: 18,
        textAlign: 'center',
    },
    closeBlock: {
        marginTop: 10,
        borderColor: 'white',
        borderWidth: 1.2,
        paddingVertical: 10,
        paddingHorizontal: 40,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    feedbackContainer: {
        flex: 1,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    feedbackAssetContainer: {
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    feedbackInfoContainer: {
        alignItems: 'center',
        alignSelf: 'flex-start',
        justifyContent: 'center',
        marginTop: 5,
    },
    feedbackAsset: {
        marginTop: 0,
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        width: width * 0.65,
        height: width * 0.65,
    },
    feedbackQuestion: {
        fontSize: 17,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
        marginTop: 30,
        marginBottom: 10,
        marginHorizontal: 10,
    },
    surveyBlock: {
        paddingBottom: 0,
        marginHorizontal: 20,
    },
    feedbackScore: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        color: TriviaTheme.txtTriviaColorTitles,
        marginTop: 25,
        marginBottom: 25,
        marginHorizontal: 20,
    },
    imageContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap', // Permite que las imágenes se envuelvan a la siguiente fila si no caben en la actual
        justifyContent: 'center', // Centra las imágenes horizontalmente
        alignItems: 'center', // Centra las imágenes verticalmente
    },
    optionImage: {
        width: Dimensions.get('window').width * 0.35,
        aspectRatio: 1 / 1,
        borderRadius: 10,
        margin: 10,
        overflow: 'hidden',
    },
    optionImage2: {
        width: Dimensions.get('window').width * 0.25,
        borderRadius: 10,
        margin: 5,
    },
    selectedOptionImage: {
        borderColor: TriviaTheme.triviaColorTextFillingBlank, // Estilo adicional para la imagen seleccionada
        borderWidth: 4,
    },
    optionChip: {
        borderRadius: 15,
        borderColor: 'rgb(1, 111, 240)',
        minWidth: 100,
        borderWidth: 1.5,
    },
    chip: {
        //marco doteado
        borderRadius: 15,
        borderColor: 'white',
        minWidth: 90,
        height: 'auto',
        textAlign: 'center',
        marginRight: 10,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        borderWidth: 1,
        borderStyle: 'dashed', // Agrega líneas punteadas al borde,
    },
    complete: {
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
    },
    chipText: {
        // color palabra elegida en trivia
        fontSize: 24,
        fontWeight: 'bold',
        marginRight: 10,
        width: 'auto',
        color: GamificationGameTheme.fillBlanksTextColor,
    },
    modalText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 10,
        fontWeight: 'bold',
    },
    modalText2: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
    },
    modalText3: {
        fontSize: 12,
        color: 'black',
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10,
    },

    container_image: {
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        marginTop: 10,
    },
    modalImage: {
        width: Dimensions.get('window').width / 10,
        resizeMode: 'cover',
        borderRadius: 10,
        alignContent: 'center',
        aspectRatio: 1 / 1,
    },
    IntermodalImage: {
        width: 150,
        height: 150,
        borderRadius: 0,
    },
    modalBox: {
        backgroundColor: 'white',
        width: Dimensions.get('window').width * 0.8,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        color: theme.colors.modalBackground,
        padding: 35,
    },
    buttonLine: {
        fontSize: 12,
        color: 'white',
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        paddingVertical: 10,
        backgroundColor: theme.colors.colorSecondary,
    },
    modalImageRespuesta: {
        width: 250,
        height: 250,
        resizeMode: 'contain',
        marginVertical: 20,
        marginBottom: 5,
    },
    feedbackTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        color: GamificationGameTheme.feedBackTitle,
        marginBottom: 25,
        width: Dimensions.get('window').width * 0.65,
    },
    feedbackDescription: {
        fontSize: 13,
        textAlign: 'center',
        color: 'white',
        width: Dimensions.get('window').width * 0.6,
        height: 85,
        paddingTop: 1,
    },

    feedbackDescription2: {
        fontSize: 18,
        textAlign: 'center',
        color: 'white',
        paddingHorizontal: 20,
        marginBottom: 7,
    },
    feedbackDescription3: {
        fontSize: 14,
        textAlign: 'center',
        color: 'white',
        paddingHorizontal: 20,
        marginBottom: -2,
        width: Dimensions.get('window').width * 0.65,
    },
    feedbackDescription4: {
        fontSize: 14,
        textAlign: 'center',
        color: 'white',
        paddingHorizontal: 20,
        marginBottom: 30,
        width: Dimensions.get('window').width * 0.65,
    },
    closeText: {
        fontSize: 12,
        color: 'white',
        borderRadius: 25,
        width: Dimensions.get('window').width * 0.65,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        paddingVertical: 10,
        backgroundColor: theme.colors.colorSecondary,
    },
    closeText2: {
        fontSize: 12,
        color: 'white',
        borderRadius: 25,
        borderColor: 'white',
        borderWidth: 1,
        width: Dimensions.get('window').width * 0.65,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        paddingVertical: 10,
        backgroundColor: theme.colors.triviaTimeOutGradientStart,
    },
    closeTextTransparent: {
        fontSize: 12,
        fontWeight: 'bold',
        borderRadius: 20,
        color: 'white',
        borderColor: 'white',
        borderWidth: 1,
        width: Dimensions.get('window').width * 0.65,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        paddingVertical: 10,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        marginTop: 1,
    },
    highLightOptionCorrectContainer: {
        backgroundColor: HighLightColors.correctBackgorundColor,
        borderColor: HighLightColors.correctBorderColor,
    },
    highLightOptionCorrectText: {
        color: HighLightColors.correctTextColor,
    },
    highLightOptionIncorrectContainer: {
        backgroundColor: HighLightColors.incorrectBackgorundColor,
        borderColor: HighLightColors.incorrectBorderColor,
    },
    highLightOptionIncorrectText: {
        color: HighLightColors.incorrectTextColor,
    },
    correctNotSelectedContainer: {
        backgroundColor: 'white',
        borderColor: HighLightColors.correctBorderColor,
        borderWidth: 3,
    },
    correctNotSelectedText: {
        color: 'black',
    },
})

export default styles
